export function ReviewUpdateIcon({ color = "#192048", className }: { color?: string; className?: string }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      className={className}
    >
      <path
        d="M7.33335 5.83275V8.28609C7.33335 8.51942 7.46002 8.73942 7.66002 8.85942L9.74002 10.0928C9.98002 10.2328 10.2867 10.1528 10.4267 9.91942C10.5667 9.67942 10.4933 9.37275 10.2533 9.23275L8.34002 8.09275V5.82609C8.33335 5.55942 8.10668 5.33275 7.83335 5.33275C7.56002 5.33275 7.33335 5.55942 7.33335 5.83275ZM14 6.33275V2.80609C14 2.50609 13.64 2.35942 13.4333 2.57275L12.2467 3.75942C11.6222 3.1349 10.8677 2.65577 10.0368 2.35617C9.20603 2.05657 8.31937 1.94387 7.44002 2.02609C4.64668 2.27942 2.34668 4.52609 2.04002 7.31942C1.87791 8.88567 2.33801 10.4529 3.32104 11.6829C4.30408 12.913 5.73127 13.7073 7.29471 13.8946C8.85816 14.0818 10.4325 13.6469 11.6782 12.6837C12.9239 11.7206 13.741 10.3063 13.9533 8.74609C14 8.34609 13.6867 7.99942 13.2867 7.99942C12.9533 7.99942 12.6733 8.24609 12.6333 8.57275C12.3467 10.8994 10.34 12.6994 7.93335 12.6661C5.46002 12.6328 3.37335 10.5461 3.33335 8.06609C3.29335 5.46609 5.40668 3.33275 8.00002 3.33275C9.28668 3.33275 10.4534 3.85942 11.3 4.69942L9.90668 6.09275C9.69335 6.30609 9.84002 6.66609 10.14 6.66609L13.6667 6.66609C13.8533 6.66609 14 6.51942 14 6.33275Z"
        fill={color}
      />
    </svg>
  );
}

export function ReviewFileHistory({
  color = "#192048",
  className,
}: {
  color?: string;
  className?: string;
  /** DEAD PROP: the caller passes a size this fixed-viewBox icon ignores. */ size?: string | number;
}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      className={className}
    >
      <path
        d="M13.3562 4.14376L10.8562 1.64376C10.761 1.5509 10.633 1.49926 10.5 1.50001L5.5 1.50001C5.23478 1.50001 4.98043 1.60536 4.79289 1.7929C4.60536 1.98044 4.5 2.23479 4.5 2.50001V3.50001L3.5 3.50001C3.23478 3.50001 2.98043 3.60536 2.79289 3.7929C2.60536 3.98044 2.5 4.23479 2.5 4.50001L2.5 13.5C2.5 13.7652 2.60536 14.0196 2.79289 14.2071C2.98043 14.3946 3.23478 14.5 3.5 14.5L10.5 14.5C10.7652 14.5 11.0196 14.3946 11.2071 14.2071C11.3946 14.0196 11.5 13.7652 11.5 13.5V12.5H12.5C12.7652 12.5 13.0196 12.3946 13.2071 12.2071C13.3946 12.0196 13.5 11.7652 13.5 11.5L13.5 4.50001C13.5007 4.36698 13.4491 4.23901 13.3562 4.14376ZM10.5 13.5L3.5 13.5L3.5 4.50001L8.29375 4.50001L10.5 6.70626L10.5 13.5ZM12.5 11.5H11.5L11.5 6.50001C11.5007 6.36698 11.4491 6.23901 11.3562 6.14376L8.85625 3.64376C8.761 3.5509 8.63302 3.49926 8.5 3.50001L5.5 3.50001V2.50001L10.2937 2.50001L12.5 4.70626L12.5 11.5ZM9 9.5C9 9.63261 8.94732 9.75979 8.85355 9.85356C8.75979 9.94733 8.63261 10 8.5 10L5.5 10C5.36739 10 5.24021 9.94733 5.14645 9.85356C5.05268 9.75979 5 9.63261 5 9.5C5 9.3674 5.05268 9.24022 5.14645 9.14645C5.24021 9.05268 5.36739 9 5.5 9H8.5C8.63261 9 8.75979 9.05268 8.85355 9.14645C8.94732 9.24022 9 9.3674 9 9.5ZM9 11.5C9 11.6326 8.94732 11.7598 8.85355 11.8536C8.75979 11.9473 8.63261 12 8.5 12L5.5 12C5.36739 12 5.24021 11.9473 5.14645 11.8536C5.05268 11.7598 5 11.6326 5 11.5C5 11.3674 5.05268 11.2402 5.14645 11.1465C5.24021 11.0527 5.36739 11 5.5 11L8.5 11C8.63261 11 8.75979 11.0527 8.85355 11.1465C8.94732 11.2402 9 11.3674 9 11.5Z"
        fill={color}
      />
    </svg>
  );
}
